import { ACTION_TYPE } from "../constants";

const initialState = {
  mousePosX: 0,
  mousePosY: 0,
  isMouseDown: false
};

const mouseReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPE.UPDATE_MOUSE_POSITION:
      const { x, y } = payload;
      return { ...state, mousePosX: x, mousePosY: y };

    case ACTION_TYPE.UPDATE_MOUSE_DOWN:
      const { isMouseDown } = payload;
      return { ...state, isMouseDown };

    default:
      return { ...state };
  }
};

export default mouseReducer;
